"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureClient = void 0;
const axios_1 = __importDefault(require("axios"));
const nestGet_1 = __importDefault(require("./nestGet"));
const configureClient = (getReduxState, getNextConfig) => (baseUrl) => {
    const { serverRuntimeConfig, publicRuntimeConfig } = getNextConfig();
    const urlConvert = serverRuntimeConfig.urlConvert || publicRuntimeConfig.urlConvert || {};
    let convertedUrl = baseUrl;
    if (process.env.IS_DOCKER) {
        Object.entries(urlConvert).forEach(([from, to]) => {
            convertedUrl = convertedUrl.replace(new RegExp(`${from}(?<=^(?:[\\w]+:\\/\\/)?${from})`), to);
        });
    }
    const options = {
        baseURL: convertedUrl,
        headers: {
            'x-mmm-app': process.env.NEXT_PUBLIC_APP_NAME || 'unknown',
        },
    };
    const token = (0, nestGet_1.default)(getReduxState(), ['authStore', 'id_token']);
    if (token) {
        options.headers.Authorization = `Bearer ${token}`;
    }
    const client = axios_1.default.create(options);
    client.interceptors.request.use((requestConfig) => requestConfig, (requestError) => (Promise.reject(requestError)));
    client.interceptors.response.use((response) => response, (error) => (Promise.reject(error)));
    return client;
};
exports.configureClient = configureClient;
